// Container for rendering tree hierarchy
import React, { useContext, useEffect } from "react";
import TreeChart from "../graphs/TreeChart";
import GaugeContext from "../../context/gauge/gaugeContext";


import { allFeatures } from "../../context/FeaturesData";

export const TreeContainer = () => {
	const gaugeContext = useContext(GaugeContext);
	const {
		nodes,
		nodeColor,
		avgNodeData,
		fetchAverageFeatureValues,
	} = gaugeContext;

	useEffect(() => {
		if (allFeatures.includes(nodeColor)) {
			fetchAverageFeatureValues(nodeColor);
		}
	}, [nodeColor]);

	if (nodes.length < 1) {
		return null;
	}
	return <div style={{overflow:"hidden", marginTop: "70px", border:"1px solid black"}}><TreeChart data={nodes} height={900}/></div>
		
};
export default TreeContainer;
